
import { mapState } from "vuex";
import VueRecaptcha from "vue-recaptcha";

import { validation } from "~/mixins";

const SUCCESS = "SUCCESS";
const ERROR = "ERROR";
const EXPIRED = "EXPIRED";

export default {
  components: { VueRecaptcha },

  mixins: [validation],

  data: () => ({
    submitting: false,
    enquiry: "",
    firstName: null,
    lastName: null,
    email: null,
    suburb: null,
    postcode: null,
    phoneNumber: null,
    message: null,
    recaptcha: null,
    errors: {
      enquiry: [],
      firstName: [],
      lastName: [],
      email: [],
      suburb: [],
      postcode: [],
      phoneNumber: [],
      message: [],
      recaptcha: [],
    },
    formErros: [],
  }),

  computed: {
    ...mapState(["siteConfig"]),
    zendeskEnquiryFields() {
      return [
        { title: "Nature of Enquiry", value: "" },
        { title: "General", value: "general" },
        { title: "Franchise", value: "franchise" },
        { title: "Complaints", value: "complaints" },
      ];
    },
  },

  methods: {
    validateEnquiry() {
      this.errors.enquiry = [];
      if (!this.enquiry) {
        this.errors.enquiry.push("Please fill this field");
      }
    },
    validateFirstName() {
      this.errors.firstName = [];
      if (!this.firstName) {
        this.errors.firstName.push("Please fill this field");
      }

      if (/[^ A-Za-z0-9_]/.test(this.firstName)) {
        this.errors.firstName.push("Please enter valid first name");
      }
    },
    validateLastName() {
      this.errors.lastName = [];
      if (!this.lastName) {
        this.errors.lastName.push("Please fill this field");
      }

      if (/[^ A-Za-z0-9_]/.test(this.lastName)) {
        this.errors.lastName.push("Please enter valid last name");
      }
    },
    validateMyEmail() {
      this.errors.email = [];
      if (!this.email) {
        this.errors.email.push("Please fill this field");
      }

      if (!this.validateEmail(this.email)) {
        this.errors.email.push("Please include @ and . in email address");
      }
    },
    validateSuburb() {
      this.errors.suburb = [];
      if (!this.suburb) {
        this.errors.suburb.push("Please fill this field");
      }

      if (/[^ A-Za-z0-9_]/.test(this.suburb)) {
        this.errors.suburb.push("Please enter valid suburb");
      }
    },
    validatePostcode() {
      this.errors.postcode = [];
      if (!this.postcode) {
        this.errors.postcode.push("Please fill this field");
      }

      if (!/^\d{4}$/.test(this.postcode)) {
        this.errors.postcode.push("Please enter valid postcode");
      }
    },
    validatePhoneNumber() {
      this.errors.phoneNumber = [];
      if (!this.phoneNumber) {
        this.errors.phoneNumber.push("Please fill this field");
      }

      if (!/^\d{10}$/.test(this.phoneNumber)) {
        this.errors.phoneNumber.push("Please enter valid phone number");
      }
    },
    validateMessage() {
      this.errors.message = [];
      if (!this.message) {
        this.errors.message.push("Please fill this field");
      }
    },
    validateRecaptcha() {
      this.errors.recaptcha = [];
      if (!this.recaptcha) {
        this.errors.recaptcha.push("Please tick the recaptcha");
      }

      if (this.recaptcha == ERROR) {
        this.errors.recaptcha.push(
          "To continue, make sure you are not a robot"
        );
      }
    },
    validate() {
      this.validateEnquiry();
      this.validateFirstName();
      this.validateLastName();
      this.validateMyEmail();
      this.validateSuburb();
      this.validatePostcode();
      this.validatePhoneNumber();
      this.validateMessage();
      this.validateRecaptcha();
    },
    onRecaptchaVerify(response) {
      this.recaptcha = response ? SUCCESS : ERROR;
      this.validateRecaptcha();
    },
    onRecaptchaError() {
      this.recaptcha = ERROR;
      this.validateRecaptcha();
    },
    onRecaptchaExpired() {
      this.recaptcha = EXPIRED;
      console.log("Recaptcha expired resetting ...");
      this.$refs.recaptcha.reset();
      this.recaptcha = null;
      this.validateRecaptcha();
    },

    async onSubmit() {
      this.validate();

      if (this.hasErros()) {
        return false;
      }

      this.submitting = true;
      this.formErros = [];

      await this.sendMail();

      if (this.formErros.length === 0) {
        this.$router.push("/contact-us/success");
      }
      this.submitting = false;
    },
    async sendMail() {
      const body = {
        enquiry: this.enquiry,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        suburb: this.suburb,
        postcode: this.postcode,
        phoneNumber: this.phoneNumber,
        message: this.message,
      };

      try {
        await this.$axios.post("api/send-mail", body);
      } catch (err) {
        this.$bugsnag.notify(err, e => e.addMetadata("body", body));
        this.formErros.push("Some error occurred");
      }
    },
  },
};
